module.exports = __webpack_public_path__ + "img/upgrade4.4ada8d92.png";